import { Stack } from '@mui/material';
import { Dialog, TagInput, TextField } from 'components/commons';
import { QuerySearchUserType } from 'pages/Home';
import React, { FC } from 'react';
import ja from 'utils/ja';

interface SearchUserDialogProps {
  data: QuerySearchUserType;
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  handleChangeText?:
    | React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
  handleChangeTag: (key: string, value: string) => void;
}

const SearchUserDialog: FC<SearchUserDialogProps> = ({
  data,
  open,
  handleClose,
  handleConfirm,
  handleChangeText,
  handleChangeTag,
}) => {
  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      title={ja.home.dialog.search}
      isSearch
    >
      <Stack
        padding='15px 10px'
        sx={{
          width: { xs: '80vw', sm: '500px' },
          '& *': { fontSize: '18px !important' },
        }}
        gap='15px'
      >
        <TextField
          id='displayName'
          label={ja.home.dialog.display_name}
          placeholder={ja.home.dialog.display_name_placeholder}
          value={data.displayName}
          onChange={handleChangeText}
        />
        <TextField
          id='affiliation'
          label={ja.home.dialog.affiliation}
          placeholder={ja.home.dialog.affiliation_placeholder}
          value={data.affiliation}
          onChange={handleChangeText}
        />
        <TagInput
          id='tag'
          label={ja.home.dialog.tag}
          placeholder={ja.home.dialog.tag_placeholder}
          limitTags={3}
          value={data.tag}
          onChange={(value: string) => handleChangeTag('tag', value)}
        />
      </Stack>
    </Dialog>
  );
};

export default SearchUserDialog;
